'use strict';

var _objectSpread = require("/var/lib/jenkins/workspace/prod-spectrum-publisher/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
let Container = require('./container');
let LazyResult, Processor;
class Document extends Container {
  constructor(defaults) {
    // type needs to be passed to super, otherwise child roots won't be normalized correctly
    super(_objectSpread({
      type: 'document'
    }, defaults));
    if (!this.nodes) {
      this.nodes = [];
    }
  }
  toResult() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let lazy = new LazyResult(new Processor(), this, opts);
    return lazy.stringify();
  }
}
Document.registerLazyResult = dependant => {
  LazyResult = dependant;
};
Document.registerProcessor = dependant => {
  Processor = dependant;
};
module.exports = Document;
Document.default = Document;